module.exports = __webpack_public_path__ + "static/media/take_photo.2aff15a4.png";